import { useMemo } from 'react'
import { useTranslation } from 'react-i18next'

import { AffUserData } from '@/api/affiliate/types/Affiliate'
import { CopyTextButton } from '@/components/CopyTextButton'
import CouponIcon from '@/components/icons/coupon.svg?react'
import { TrophyIcon } from '@/components/icons/TrophyIcon'
import { UsersIcon } from '@/components/icons/UsersIcon'
import { Card, CardContent } from '@/components/ui/card'

import { AffiliateCouponSection } from './AffiliateCouponSection'

interface AffiliateCouponsTabProps {
  refUserData: AffUserData
}

export const AffiliateCouponsTab = ({ refUserData }: AffiliateCouponsTabProps) => {
  const { t } = useTranslation()
  const refNum = refUserData?.affLinks[0]?.code || ''
  const coupons = refUserData?.coupons
  const totalEarningsCoupons =
    (refUserData?.couponIncomeOffset || 0) + (coupons?.reduce((sum, coupon) => sum + Math.round(coupon.totalPaymentRevenue || 0), 0) || 0)

  const totalEarningsShipments = Math.round(refUserData?.pkgIncome || 0)

  const totalCouponUsage = useMemo(() => {
    return coupons?.reduce((acc, coupon) => acc + coupon.timesUsed, 0) || 0
  }, [coupons])
  const totalRevenue = totalEarningsCoupons + totalEarningsShipments

  return (
    <div className='space-y-4 md:space-y-6'>
      <Card className='bg-white'>
        <CardContent className='space-y-2'>
          <div className='text-text-secondary text-sm'>{t('affiliate.yourLink')}</div>
          <div className='flex items-center gap-2'>
            <CopyTextButton tooltipText={t('affiliate.copied')} value={`https://shiptanbul.com/?ref=${refNum}`} />
            <div dir='ltr' className='bg-background-secondary text-text-secondary flex-1 rounded-lg p-2 text-sm'>
              {`https://shiptanbul.com/?ref=${refNum}`}
            </div>
          </div>
          <div className='grid grid-cols-1 gap-3 md:grid-cols-3'>
            <div className='bg-button-primary-selected-segment rounded-md p-3'>
              <div className='text-text-secondary mb-2 flex items-center justify-between text-sm'>
                {t('affiliate.registeredUsers')}
                <UsersIcon className='size-4' />
              </div>
              <div className='text-text-secondary text-base leading-none font-medium'>{refUserData.registeredUsers || 0}</div>
            </div>
            <div className='bg-button-primary-selected-segment rounded-md p-3'>
              <div className='text-text-secondary mb-2 flex items-center justify-between text-sm'>
                {t('affiliate.couponCodeUsage')}
                <CouponIcon className='size-4' />
              </div>
              <div className='text-text-secondary text-base leading-none font-medium'>{totalCouponUsage}</div>
            </div>
            <div className='bg-button-primary-selected-segment rounded-md p-3'>
              <div className='text-text-secondary mb-2 flex items-center justify-between text-sm'>
                {t('affiliate.totalRevenue')}
                <TrophyIcon className='size-4' />
              </div>
              <div className='text-text-secondary text-base leading-none font-medium'>{`₪${totalRevenue}`}</div>
            </div>
          </div>
        </CardContent>
      </Card>
      <AffiliateCouponSection coupons={coupons} allowDailyChart />
    </div>
  )
}
